import React, { SVGProps } from 'react'
const SvgDeactivatedUserAvatar = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#697080'}
      fillRule="evenodd"
      d="M15 1.84C7.717 1.84 1.826 7.74 1.826 15c0 3.357 1.26 6.422 3.333 8.749l4.585-4.622a6.019 6.019 0 0 1-.613-2.657 6.038 6.038 0 0 1 8.652-5.445l5.887-5.933A13.129 13.129 0 0 0 15 1.84Zm9.963 4.55-5.648 5.693a6.022 6.022 0 0 1 1.887 4.387 6.025 6.025 0 0 1-2.083 4.564c1.718.371 3.09 1.035 4.046 2.054.402.429.716.902.946 1.417A13.118 13.118 0 0 0 28.174 15c0-3.29-1.21-6.3-3.21-8.61Zm-8.59 6.055a4.22 4.22 0 0 0-1.207-.175 4.205 4.205 0 0 0-4.02 5.445l5.228-5.27Zm-4.269 6.906 5.92-5.965a4.187 4.187 0 0 1 1.352 3.084 4.204 4.204 0 0 1-4.06 4.197 25.301 25.301 0 0 0-.3 0 4.198 4.198 0 0 1-2.912-1.316Zm-1.291 1.302-.654.66c.335-.107.686-.2 1.054-.28a6.095 6.095 0 0 1-.4-.38ZM15 28.16a13.12 13.12 0 0 1-7.339-2.23c.151-.64.437-1.159.83-1.578 1.047-1.115 3.108-1.822 6.503-1.844a6.201 6.201 0 0 0 .345 0c3.393.023 5.453.729 6.5 1.844.352.377.619.834.778 1.386A13.121 13.121 0 0 1 15 28.16ZM0 15C0 6.708 6.723 0 15 0c8.277 0 15 6.708 15 15 0 8.291-6.723 15-15 15-8.277 0-15-6.709-15-15Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDeactivatedUserAvatar
